import { Component, OnDestroy, OnInit } from "@angular/core";
import { EmployeeService } from "src/app/_share/_services/employee.service";
import { Employee } from "src/app/_share/_models/employee";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ConfirmationService, MessageService } from "primeng/api";
import { CreateEmployeeComponent } from "../create-employee/create-employee.component";
import { ViewEmployeeComponent } from "../view-employee/view-employee.component";

@Component({
  selector: "app-employees",
  templateUrl: "./employees.component.html",
  styleUrls: ["./employees.component.scss"],
  providers: [ConfirmationService, MessageService],
})
export class EmployeesComponent implements OnInit, OnDestroy {
  selectedRowCMObservable$: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  Employees$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  ref: DynamicDialogRef | undefined;
  employees: any[] = [];
  employeesObservable$: any;
  private subscriptions: Subscription = new Subscription();

  constructor(
    public dialogService: DialogService,
    public employeeService: EmployeeService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.Employees$.next(false);
    }, 3000);
    this.subscriptions.add(
      this.employeeService.getEmployees().subscribe((employees) => {
        this.employees = employees.filter(
          (employee) =>
            employee.status && employee.status.toLowerCase() !== "terminated"
        );
      })
    );
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getEmployeesOptionsList() {
    this.subscriptions.add(
      this.employeeService.getEmployees().subscribe((employees: any[]) => {
        this.employees = employees;
      })
    );
  }
  //ngdestroy
  //subject to table instead of list
  //employees$ = new BehaviorSubject<Employee[]>([]);
  columns = [
    { field: "status", header: "Status" },
    { field: "employee_code", header: "Employee Code" },
    { field: "first_name", header: "First Name" },
    { field: "last_name", header: "Last Name" },
    { field: "position", header: "Position" },
    { field: "department", header: "Department" },
    { field: "email", header: "Email" },
    { field: "phone_number", header: "Phone Number" },
  ];

  onGlobalSearch(event: any) {
    const searchValue = event.target.value;
    if (searchValue.trim()) {
      // Filter the employees array based on the global search query
      this.employees = this.filterEmployees(searchValue);
    } else {
      // If search is cleared, load the full list
      this.getEmployeesOptionsList();
    }
  }

  getEmployeeStatusSeverity(value: string): string {
    switch (value.toLowerCase()) {
      case "suspended":
      case "unpaid suspension":
        return "warning";
      case "active":
        return "success";
      case "terminated":
        return "danger";
      default:
        return "info";
    }
  }
  filterEmployees(query: string): any[] {
    return this.employees.filter((employee) =>
      Object.values(employee).some((value) =>
        String(value).toLowerCase().includes(query.toLowerCase())
      )
    );
  }

  showViewEmployee(rowData: any) {
    this.ref = this.dialogService.open(ViewEmployeeComponent, {
      data: rowData,

      header: "Employee Details",
      width: "90%",
      height: "70%",
      closeOnEscape: true,
    });
  }

  showAdd() {
    this.ref = this.dialogService.open(CreateEmployeeComponent, {
      data: {
        employeeData: null,
        listofemployees: this.employeeService.getEmployees(),
      },
      header: "Add Employee",
      width: "65%",
      height: "55%",
      closeOnEscape: true,
    });

    this.ref.onClose.subscribe((result) => {
      if (result) {
        this.getEmployeesOptionsList();
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: "Employee successfully added",
        });
      } else {
        this.messageService.add({
          severity: "info",
          summary: "Cancelled",
          detail: "Adding employee was cancelled",
        });
      }
    });
  }

  // Edit function
  editEmployee(rowData: any) {
    console.log("row", rowData);
    this.ref = this.dialogService.open(CreateEmployeeComponent, {
      data: {
        formdata: rowData,
      },
      header: "Edit Employee",
      width: "70%",
      height: "55%",
      closeOnEscape: true,
    });
    this.ref.onClose.subscribe((result) => {
      if (result) {
        this.getEmployeesOptionsList();
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: "Employee updated successfully",
        });
      } else {
        this.messageService.add({
          severity: "info",
          summary: "Cancelled",
          detail: "Editing employee was cancelled",
        });
      }
    });
  }
  deleteEmployee(rowData: any) {
    this.confirmationService.confirm({
      message: "Are you sure you want to delete this employee?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      accept: () => {
        this.employeeService.deleteEmployee(rowData.id).subscribe(() => {
          this.getEmployeesOptionsList();
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Employee deleted successfully",
          });
        });
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Rejected",
          detail: "Employee was not deleted",
        });
      },
    });
  }
}
